import { BackIcon } from "@components/Icons/Back";
import { LogoutIcon } from "@components/Icons/Logout";
import { useTranslation } from "@helpers/useTranslation";
import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "src/helpers/firebase";
import { useBranding } from "src/helpers/useBranding";
import { useEventNavigate } from "src/helpers/useEventNavigate";

type Props = {
  backLink?: string;
};

/** Minimal top bar for the oracle (associate) experience: brand logo, optional back, and logout. */
export const OracleNav: FC<Props> = ({ backLink }) => {
  const { auth } = useContext(FirebaseContext);
  const { logoUrl, brand } = useBranding();
  const { t } = useTranslation("admin");
  const navigate = useNavigate();
  const eventNavigate = useEventNavigate();

  const logout = async () => {
    await auth.signOut();
    navigate("/login");
  };

  return (
    <div className="navbar top-0 z-50 flex justify-between border-b-2 px-2 shadow shadow-lg shadow-base-300">
      <div className="flex items-center gap-2">
        {backLink && (
          <button className="btn-ghost btn-sm btn" onClick={() => eventNavigate(backLink)} aria-label="back">
            <BackIcon />
          </button>
        )}
        <img className={`color-white ml-2 ${brand === "tuokis" ? "h-12" : "h-5"}`} src={logoUrl} />
      </div>
      <button className="btn-ghost btn-sm btn gap-1" onClick={logout}>
        <LogoutIcon />
        <span className="hidden sm:inline">{t("logout")}</span>
      </button>
    </div>
  );
};
